import { AkaAdvicePriceFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";

export const mapToFinalAkaAdviceData = (
  priceFormValues: AkaAdvicePriceFormValues,
): AkaAdvicePriceFormValues => {
  const { disabilityOneTimePaymentChangedWarning: _, ...rest } =
    priceFormValues;
  return rest;
};
